import { APICore } from "../apiCore";

const api = new APICore();

function getLandingPageData() {
    return api.get(`/pages/landing`);
}

function getGenrePageData(genreSlug: string) {
    return api.get(`/pages/genre/${ genreSlug }`);
}

function getGenreFooterMedia(genreSlug: string) {
    return api.get(`/genre/${ genreSlug }/footer`);
}

function getShowDetailPage(genreSlug: string, showSlug: string) {
  return api.get(`/genre/${ genreSlug }/show/${ showSlug }`);
}

export { getLandingPageData, getGenrePageData, getGenreFooterMedia, getShowDetailPage };